import { APP_STORE_URL, GOOGLE_PLAY_URL } from "@/data/products";

export const AppleGlyph = ({ className }) => (
  <svg viewBox="0 0 384 512" className={className} fill="currentColor" aria-hidden="true">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
  </svg>
);

export const PlayGlyph = ({ className }) => (
  <svg viewBox="0 0 512 512" className={className} aria-hidden="true">
    <path fill="#00d4ff" d="M47 32C37 37 31 47 31 60v392c0 13 6 23 16 28l232-224z"/>
    <path fill="#00e676" d="M47 32c4-2 9-2 15 1l257 148-58 55z"/>
    <path fill="#ffce00" d="M377 205 319 181l-58 55 58 55 58-24c17-10 17-52 0-62z"/>
    <path fill="#ff3d47" d="M47 480c4 2 9 2 15-1l257-148-58-55z"/>
  </svg>
);

export const StoreButton = ({ href, glyph, top, bottom, testid, dark, compact }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className={`group inline-flex items-center gap-2 rounded-xl transition-all duration-300 ${
      compact ? "px-3 py-1.5" : "px-4 py-2.5 gap-2.5"
    } ${
      dark
        ? "bg-[#f4f1eb] text-[#12160f] hover:bg-white"
        : "bg-[#f4f1eb] text-[#12160f] hover:bg-white"
    }`}
  >
    <span className="shrink-0">{glyph}</span>
    <span className="flex flex-col leading-tight text-left">
      <span className={`uppercase tracking-[0.14em] opacity-70 ${compact ? "text-[8px]" : "text-[9px]"}`}>{top}</span>
      <span className={`font-semibold -mt-0.5 ${compact ? "text-xs" : "text-sm"}`}>{bottom}</span>
    </span>
  </a>
);

export const AppStoreButtons = ({ dark = false, compact = false, className = "" }) => {
  const size = compact ? "h-5 w-5" : "h-6 w-6";
  return (
    <div className={`flex flex-wrap items-center gap-2.5 ${className}`}>
      <StoreButton
        href={APP_STORE_URL}
        testid="app-store-btn"
        dark={dark}
        compact={compact}
        glyph={<AppleGlyph className={size} />}
        top="Download on the"
        bottom="App Store"
      />
      <StoreButton
        href={GOOGLE_PLAY_URL}
        testid="google-play-btn"
        dark={dark}
        compact={compact}
        glyph={<PlayGlyph className={size} />}
        top="Get it on"
        bottom="Google Play"
      />
    </div>
  );
};
